/* =========================================================
   CABECERA + CAJÓN
========================================================= */
(function () {
  var hdr = document.getElementById('hdr');
  if (!hdr) return;
  var tic = false;
  function alDesplazar() { hdr.classList.toggle('pegada', window.scrollY > 12); tic = false; }
  window.addEventListener('scroll', function () {
    if (!tic) { requestAnimationFrame(alDesplazar); tic = true; }
  }, { passive: true });
  alDesplazar();

  var drawer = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  if (!drawer || !burger) return;

  function abrir(v) {
    drawer.dataset.abierto = v ? 'true' : 'false';
    burger.setAttribute('aria-expanded', v ? 'true' : 'false');
    document.body.style.overflow = v ? 'hidden' : '';
    if (v) { var p = drawer.querySelector('.drawer-panel a'); if (p) p.focus(); }
    else { burger.focus(); }
  }
  burger.addEventListener('click', function () { abrir(true); });
  drawer.querySelectorAll('[data-cerrar]').forEach(function (b) {
    b.addEventListener('click', function () { abrir(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.dataset.abierto === 'true') abrir(false);
  });
})();

/* =========================================================
   CARRUSEL DEL HERO
========================================================= */
(function () {
  var hero = document.getElementById('fajaHero');
  if (!hero) return;

  var slides = hero.querySelectorAll('.faja-slide');
  var dots = hero.querySelectorAll('.faja-dot');
  var prev = hero.querySelector('.faja-prev');
  var next = hero.querySelector('.faja-next');
  var current = 0, timer = null;

  function showSlide(i) {
    if (i < 0) i = slides.length - 1;
    if (i >= slides.length) i = 0;
    slides.forEach(function (s, n) { s.classList.toggle('active', n === i); });
    dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
    current = i;
  }
  function autoPlay() {
    clearInterval(timer);
    timer = setInterval(function () { showSlide(current + 1); }, 5500);
  }

  if (prev) prev.addEventListener('click', function () { showSlide(current - 1); autoPlay(); });
  if (next) next.addEventListener('click', function () { showSlide(current + 1); autoPlay(); });
  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      showSlide(parseInt(this.getAttribute('data-slide'), 10));
      autoPlay();
    });
  });
  hero.addEventListener('mouseenter', function () { clearInterval(timer); });
  hero.addEventListener('mouseleave', autoPlay);

  showSlide(0);
  autoPlay();
})();

/* =========================================================
   CORAZONES DE FAVORITOS
========================================================= */
(function () {
  document.querySelectorAll('.best-faja-heart').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      b.classList.toggle('on');
      b.setAttribute('aria-pressed', b.classList.contains('on') ? 'true' : 'false');
    });
  });
})();

/* =========================================================
   CONTADORES DE LAS CIFRAS
   Suben de uno en uno y se detienen en su valor.
========================================================= */
(function () {
  var quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nums = [].slice.call(document.querySelectorAll('.num[data-hasta]'));
  if (!nums.length) return;

  function pinta(el, v, dec) {
    el.textContent = dec ? v.toFixed(dec).replace('.', ',') : String(v);
  }

  function contar(el) {
    var fin = parseFloat(el.dataset.hasta);
    var dec = parseInt(el.dataset.dec || 0, 10);
    var tope = Math.floor(fin);
    if (quieto || tope <= 0) { pinta(el, fin, dec); return; }

    var DURACION = 1900, intervalo = DURACION / tope;
    var actual = 0, ultimo = null;

    function paso(t) {
      if (ultimo === null) ultimo = t;
      var deberia = Math.floor((t - ultimo) / intervalo);
      if (deberia > tope) deberia = tope;
      if (deberia !== actual) { actual = deberia; pinta(el, actual, 0); }
      if (actual < tope) requestAnimationFrame(paso);
      else if (dec) setTimeout(function () { pinta(el, fin, dec); }, intervalo * 2);
    }
    requestAnimationFrame(paso);
  }

  if (!('IntersectionObserver' in window)) {
    nums.forEach(contar);
    return;
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      contar(e.target);
    });
  }, { threshold: 0.6 });
  nums.forEach(function (el) { io.observe(el); });
})();

/* =========================================================
   CARRUSEL DE RESULTADOS
   Las flechas y los puntos de tu maqueta no tenían lógica:
   aquí desplazan el carril y marcan el punto activo.
========================================================= */
(function () {
  var track = document.querySelector('.proof3d-track');
  if (!track) return;

  var cards = track.querySelectorAll('.proof3d-card');
  var prev = track.querySelector('.proof3d-arrow.left');
  var next = track.querySelector('.proof3d-arrow.right');
  var dots = document.querySelectorAll('.proof3d-dot');
  var i = 0;

  function marca(n, sinScroll) {
    i = Math.max(0, Math.min(cards.length - 1, n));
    dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    /* Bug real: esto se llamaba tambien al iniciar (marca(0) mas abajo),
       y scrollIntoView mueve la pagina entera si la tarjeta aun no esta
       a la vista (que es siempre, recien cargada la pagina). En movil
       eso hacia que la home Y la ficha de producto (esta seccion esta
       tambien en templates/product.json) aterrizaran de golpe en esta
       seccion. Ahora solo se desplaza cuando el usuario mueve el
       carrusel con las flechas o los puntos, nunca al cargar. */
    if (!sinScroll && cards[i] && window.innerWidth <= 1100) {
      cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  if (prev) prev.addEventListener('click', function () { marca(i - 1); });
  if (next) next.addEventListener('click', function () { marca(i + 1); });
  dots.forEach(function (d, k) { d.addEventListener('click', function () { marca(k); }); });

  marca(0, true);
})();
